import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import fi from './locales/fi.json';
import sv from './locales/sv.json';
import de from './locales/de.json';
import no from './locales/no.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';
import da from './locales/da.json';
import nl from './locales/nl.json';
import he from './locales/he.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ro from './locales/ro.json';
import ru from './locales/ru.json';
import pl from './locales/pl.json';
import bg from './locales/bg.json';

export type SupportedLocale = 'en' | 'fi' | 'sv' | 'de' | 'no' | 'fr' | 'es' | 'it' | 'da' | 'nl' | 'he' | 'zh' | 'ja' | 'ru' | 'pl' | 'bg' | 'ro';

export const supportedLocales: SupportedLocale[] = ['en', 'fi', 'sv', 'de', 'no', 'fr', 'es', 'it', 'da', 'nl', 'he', 'zh', 'ja', 'ru', 'pl', 'bg', 'ro'];

// Restore saved locale preference BEFORE creating i18n so every component
// (including SupportPage article content) renders in the correct language
// from the very first frame — no flash-of-wrong-locale.
function getInitialLocale(): SupportedLocale {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('cpt-locale') as SupportedLocale | null;
    if (saved && supportedLocales.includes(saved)) return saved;
  }
  return 'en';
}

const i18n = createI18n<[typeof en], SupportedLocale>({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ro,
    fi,
    sv,
    de,
    no,
    fr,
    es,
    it,
    da,
    nl,
    he,
    zh,
    ja,
    ru,
    pl,
    bg,
  },
});

export default i18n;
